import { QueryCache, VueQueryPlugin, VueQueryPluginOptions } from '@tanstack/vue-query'
import { AxiosError } from 'axios'

import { defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin(nuxtApp => {
  const queryPluginOptions: VueQueryPluginOptions = {
    queryClientConfig: {
      queryCache: new QueryCache(),
      defaultOptions: {
        queries: {
          refetchOnMount: false,
          refetchOnWindowFocus: false,
          refetchOnReconnect: false,
          refetchInterval: false,
        },
      },
    },
  }
  nuxtApp.vueApp.use(VueQueryPlugin, queryPluginOptions)
})